/**
 * SRS ブログ NEW アイコン表示
 * - 公開日から7日以内の記事に .show を付与
 * - 判定時刻は HEAD レスポンスの Date ヘッダー（クライアント時刻ずれ対策）
 * - 対象: .srs-custom-blog-section 内の .new-icon
 */
(function () {
  function showNewIcon(now) {
    var newIconList = document.querySelectorAll('.srs-custom-blog-section .new-icon');

    newIconList.forEach(function (newIcon) {
      var dateStr = newIcon.dataset.articlePublishedAt;
      if (!dateStr) return;

      var publishedMs = parseInt(dateStr, 10) * 1000;
      if (isNaN(publishedMs)) return;

      var articlePublishedAt = new Date(publishedMs);
      if (isNaN(articlePublishedAt.getTime())) return;

      var oneWeekAfter = new Date(articlePublishedAt);
      oneWeekAfter.setDate(oneWeekAfter.getDate() + 7);

      if (articlePublishedAt <= now && now <= oneWeekAfter) {
        newIcon.classList.add('show');
      }
    });
  }

  function initNewIcons() {
    fetch(window.location.href, {
      method: 'HEAD',
      cache: 'no-store',
    })
      .then(function (response) {
        var dateHeader = response.headers.get('Date');
        if (dateHeader) {
          var parsed = new Date(dateHeader);
          showNewIcon(!isNaN(parsed.getTime()) ? parsed : new Date());
        } else {
          showNewIcon(new Date());
        }
      })
      .catch(function () {
        showNewIcon(new Date());
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewIcons);
  } else {
    initNewIcons();
  }

  document.addEventListener('shopify:section:load', initNewIcons);
})();
